import { Outlet } from "react-router-dom"
import Header from "./Header"
import Sidebar from "./Sidebar"

import InternetConnection from "../components/InternetConnection"
import { useSelector } from "react-redux"

export default () => {
    const { isSidebarCollapse } = useSelector(state => state.common)
    const width = window.innerWidth 

    return (
        <InternetConnection >
            <Sidebar />
            <Header />

            <section className="pc-container" style={{ marginLeft: isSidebarCollapse ? "80px" : width > 498 && "280px"}}>
                <div className="pc-content" >
                    <Outlet />
                </div>
            </section>
        </InternetConnection>
    )
}